export default "__VITE_ASSET__CVAY3tdb__"